<div class="flex justify-content-center align-items-center font-bold text-xl" *ngIf="onExtendedMobile()">
	{{ titleId | translate }}
</div>
<div class="layout-content p-0 pt-3" [ngClass]="layoutMarginResponsive()">
	<app-site-selector></app-site-selector>
	<div class="grid p-0 px-2 mt-3 mb-5 lg:mb-3 sm:mt-0 md:p-1">
		<div class="col-12">
			<app-scenery-tab-group></app-scenery-tab-group>
		</div>
	</div>
</div>